import { InfoOutlined } from "@mui/icons-material";
import { InputLabel, Tooltip, Typography, Box, Grid } from "@mui/material";
import React from "react";

export interface MappedItem {
  label: string;
  labelId?: string;
  value: React.ReactNode;
}

export interface MapListProps {
  items: MappedItem[];
}

const tdStyle: React.CSSProperties = { paddingRight: 10, paddingTop: 10 };

export const Hint = ({ toolTip }: { toolTip?: string | null }) => {
  if (!toolTip) return null;
  return (
    <Tooltip title={toolTip} placement="top">
      <InfoOutlined
        sx={{
          ml: 1,
          color: "text.secondary",
          cursor: "pointer",
          fontSize: "1.2rem",
        }}
      />
    </Tooltip>
  );
};

const Label = ({ label, labelId }: MappedItem) => {
  // If labelId is supplied, use an InputLabel
  const labelElem = labelId ? (
    <InputLabel id={labelId} sx={{ color: "text.primary" }}>
      {label}:
    </InputLabel>
  ) : (
    <Typography>{label}:</Typography>
  );
  return labelElem;
};

export const MapList = ({ items }: MapListProps) => {
  return (
    <table>
      {items.map((item, index) => {
        return (
          <tr key={index}>
            <td style={tdStyle}>
              <Label {...item} />
            </td>
            <td style={tdStyle}>
              <Box
                sx={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                {item.value}
              </Box>
            </td>
          </tr>
        );
      })}
    </table>
  );
};

export const GridList = ({ items }: MapListProps) => {
  return (
    <Grid container spacing={2} maxWidth={800}>
      {items.map((item) => {
        return (
          <>
            <Grid
              item
              xs={5}
              md={4}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Label {...item} />
            </Grid>
            <Grid item xs={7} md={8}>
              {item.value}
            </Grid>
          </>
        );
      })}
    </Grid>
  );
};
